import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { SalaryContext } from '../../../models/payroll-currency.model';
import { AdminService } from '../../../services/admin.service';
import { UserService } from '../../../services/user.service';
import {GradePromotionService} from '../../../services/grade-promotion.service';
import {GradePromotionEvent} from '../../common/grade-growth/grade-growth.model';
import { EmployeeProbationResponse } from './view-user-profile.types';

@Injectable()
export class ViewUserProfilePayrollGateway {
  constructor(private adminService: AdminService, private userService: UserService, private promotions: GradePromotionService) {}

  get promotionCommitted$(): Observable<GradePromotionEvent> { return this.promotions.promotionCommitted$; }

  salaryContext(userId: string): Observable<SalaryContext> {
    return this.adminService.getSalaryContext(userId);
  }

  probation(userId: string): Observable<HttpResponse<EmployeeProbationResponse>> {
    return <Observable<HttpResponse<EmployeeProbationResponse>>><Object>
      this.userService.getEmployeeProbation(userId);
  }

  approveProbation(userId: string): Observable<HttpResponse<EmployeeProbationResponse>> {
    return <Observable<HttpResponse<EmployeeProbationResponse>>><Object>
      this.userService.approveEmployeeProbation(userId);
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-user-profile/view-user-profile-payroll.gateway.ts